exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "html[data-v-1d56c086]{scroll-behavior:smooth}.question[data-v-1d56c086]{font-size:13px}", ""]);

// exports
